<template>
  <div class="container-frame">
    <iframe ref="frameRef" allowfullscreen="true"  class="frame-box"  allow="microphone *;camera *;midi *;encrypted-media *; "  :src="urlStr" frameborder="0" width="100%"   scrolling="auto"></iframe>
  </div>
</template>

<script>
export default {
  name: "bjyStudent",
  data(){
    return{
      urlStr:'',
      contentId:'',
      isLiveType: '' // 判断直播类型
    }
  },
  async mounted(){
    let wakeLock = null;
    const requestWakeLock = async () => {
      try {
        wakeLock = await navigator.wakeLock.request();
        wakeLock.addEventListener('release', () => {
          console.log('Screen Wake Lock released:', wakeLock.released);
        });
        console.log('Screen Wake Lock released:', wakeLock.released);
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    };
    await requestWakeLock();
    const handleVisibilityChange = async () => {
      if (wakeLock !== null && document.visibilityState === 'visible') {
        await requestWakeLock();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.setTimeout(() => {
      wakeLock.release();
      wakeLock = null;
    }, 5000);

    this.$nextTick(()=>{
      this.$refs.frameRef.style.height = `${window.innerHeight-50}px`
      this.getUrlData()
    })
  },
  methods:{
    getUrlData() {
      this.$api.live.getBjyPlayUrl({liveCourseId: this.$route.query.contentId}).then(async (resB) => {
          this.urlStr = resB.data.url
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container-frame{
  //height: 100vh;
}
</style>
